import {
    Add,
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Download,
    Edit,
} from "@mui/icons-material";
import {
    Alert,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import LoadingAnimation from "../../../../Components/LottieAnimation/LoadingAnimation";
import { ButtonTable } from "../../../../Layouts/ButtonsControlled";
import {
    TableCellStyle,
    TableHeadStyled,
    TableRowStyled,
    TableContainerStyled,
} from "../../../../Layouts/TableStyle";
import {
    GetInstallerAdders,
    GetInstallerLicense,
    reset,
} from "../../../../Redux/InstallerSlice/InstallerSlice";

const InstallerLicense = () => {
    const dispatch = useDispatch();
    const { installer_id } = useParams();

    const { license, isLodaing } = useSelector((state) => state.installer);
    const LICENSE = license?.data?.business_licence;
    const CallInstallerAdderMethod = async () => {
        await dispatch(GetInstallerLicense(installer_id));
        await dispatch(reset());
    };
    useEffect(() => {
        console.log(LICENSE);
        CallInstallerAdderMethod();
    }, []);
    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <>
                    <ButtonContainer>
                        <Link
                            className="create-btn"
                            mt={3}
                            sx={{ float: "right", margin: "10px" }}
                            to="create"
                        >
                            <ButtonTable startIcon={<Add />}>
                                New License
                            </ButtonTable>
                        </Link>
                    </ButtonContainer>
                    <TableContainerStyled>
                        <Table aria-label="simple table">
                            <TableHeadStyled>
                                <TableRow>
                                    <TableCell> # </TableCell>
                                    <TableCell> Full Address </TableCell>
                                    <TableCell> License Holder </TableCell>
                                    <TableCell>
                                        {" "}
                                        License Expiration Date{" "}
                                    </TableCell>
                                    <TableCell> License Number </TableCell>
                                    <TableCell> license_type </TableCell>
                                    <TableCell> Phone </TableCell>
                                    <TableCell> State </TableCell>
                                    <TableCell> Action </TableCell>
                                </TableRow>
                            </TableHeadStyled>

                            <TableBody>
                                {LICENSE?.map((key, index) => (
                                    <TableRowStyled key={index}>
                                        <TableCellStyle>
                                            {index + 1}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.full_address}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.license_holder}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.license_expiration_date}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.license_number}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.license_type}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.phone}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.state}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            <IconButton>
                                                <a
                                                    href={
                                                        key?.file?.license_img
                                                    }
                                                    download
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                >
                                                    <Download color="primary" />
                                                </a>
                                            </IconButton>
                                            <IconButton>
                                                <Link to={`edit=${key.id}`}>
                                                    <Edit color="success" />
                                                </Link>
                                            </IconButton>
                                            {/* <IconButton
                                    // onClick={(e) => handelDeleteAdder(key)}
                                    >
                                        <Link to={"#"}>
                                            <Delete color="error" />
                                        </Link>
                                    </IconButton> */}
                                        </TableCellStyle>
                                    </TableRowStyled>
                                ))}
                            </TableBody>
                        </Table>

                        {typeof LICENSE !== "undefined" &&
                            LICENSE.length === 0 && (
                                <Alert severity="error">
                                    This is an error alert — check it out!
                                </Alert>
                            )}

                        {/* EDIT MODAL  */}
                        {/* <PopupModal open={edit} close={handelCloseEditRow}>
                    <EditAdder data={data} />
                </PopupModal> */}

                        {/* Update Adder Status MODAL  */}
                        {/* <PopupModal open={status} close={handelCloseStatusRow}>
                    <AdderStatusConfirm
                        data={data}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        status={setStatus}
                        close={handelCloseStatusRow}
                    />
                </PopupModal> */}

                        {/* delete modal  */}
                        {/* <DeleteModal
                    open={open}
                    close={handleClose}
                    title={data?.name}
                    onClick={DeleteRow}
                    loading={isLodaing}
                /> */}
                    </TableContainerStyled>
                </>
            )}
        </>
    );
};

const ButtonContainer = styled.div`
    .create-btn {
        margin: 10px;
        float: right;
    }
`;

export default InstallerLicense;
